<template>
  <div>
    <dialog-v2 :show="show" :title="dialogTitle" :disableSaveBtn="!canCreate" max-width="600px" @close="closeDialog" @save="save">
      <template slot="title">
        <v-btn v-if="canCreate" flat icon @click.stop="deleteFilter">
              <v-icon color="red" small>
                fas fa-trash-alt
              </v-icon>
            </v-btn>
      </template>
      <template slot="content">
        <v-layout row wrap>
          <v-flex md10 pr-4>
            <v-text-field v-model="form.name" v-validate="'required|max:100'" data-vv-name="name" data-vv-scope="filter"
              data-vv-as="nombre" :error-messages="errors.collect('name', 'filter')" label="Nombre" color="black" />
          </v-flex>
          <v-flex md2>
            <v-text-field v-model.number="form.order" v-validate="`required|integer|min_value:1|max_value:${maxOrder}`"
              data-vv-name="order" data-vv-scope="filter" data-vv-as="order" :error-messages="errors.collect('order', 'filter')"
              label="Orden" color="black" />
          </v-flex>
        </v-layout>
        <v-layout row wrap mb-4>
          <v-flex md4>
            <v-switch label="No gestionar" v-model="form.no_management" class="k-blue-linear-text" :hide-details="true">
            </v-switch>
          </v-flex>
        </v-layout>
        <template v-if="!form.no_management">
          <v-layout row wrap>
            <v-flex :md7="form.type_id === 2">
              <v-select v-model="form.type_id" :items="types" item-value="id" item-text="label" v-validate="'required'"
                data-vv-scope="filter" data-vv-name="type" data-vv-as="Tipo" :error-messages="errors.collect('type_id', 'filter')"
                label="Tipo de gestión" color="black">
              </v-select>
            </v-flex>
            <v-flex md5 pl-4 v-if="form.type_id === 2">
              <v-text-field v-model="form.fixed_hour" label="Hora" ref="hour" type="time" v-validate="'required'"
                data-vv-name="hour" data-vv-scope="filter" :error-messages="errors.collect('fixed_hour', 'filter')" color="black">
              </v-text-field>
            </v-flex>
          </v-layout>
        </template>
        <filters-list v-if="activeFilters" v-model="form.filters" :default-filters="form.filters" :key="filtersListKey" />
      </template>
    </dialog-v2>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import Scrollbar from 'vue-perfect-scrollbar';
import DialogV2 from '@/components/global/DialogV2';
import FiltersList from '@/components/global/CustomerFilters/Index';
import channelsMixin from '@/mixins/channelsV2';
import filtersMixin from '@/mixins/workflowFilters';
import comparisonOperatorsMixin from '@/mixins/comparisonOperators';
import EventBus from '@/event-bus';
import permissionsMixin from '@/mixins/permissions';

const uuidv1 = require('uuid/v1');

export default {
  inject: ['$validator'],
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    stage: {
      type: Object,
      required: true,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    isWorkflowSmsConfigActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DialogV2,
    Scrollbar,
    FiltersList,
  },
  mixins: [
    channelsMixin,
    comparisonOperatorsMixin,
    permissionsMixin,
  ],
  data() {
    const emptyForm = {
      name: '',
      order: '',
      days_off: '',
      company_email_id: null,
      bot_template_id: null,
      ivr_template_id: null,
      whatsapp_template_id: null,
      subject: '',
      send_human: 0,
      send_bot: 0,
      send_email: 0,
      send_sms: 0,
      send_ivr: 0,
      send_visit: 0,
      send_whatsapp: 0,
      no_management: false,
      valid_only_sms: false,
      only_contacted_sms: false,
      bot_calls_queue: 1,
      ivr_calls_queue: 1,
      ivr_max_attempts: 3,
      bot_max_attempts: 3,
      human: '',
      email: '',
      sms: '',
      ivr: '',
      visit: '',
      filters: {
        type: 'group',
        operator: 'and',
        items: [],
      },
      days_off_g1: 0,
      days_off_g2: 0,
      days_off_g3: 0,
      days_off_g4: 0,
      fixed_hour: '',
      type_id: 1,
      sms_cs_journey: null,
      sms_check_days: null,
      sms_owner_id: null,
      ivr_owner_id: null,
      bot_owner_id: null,
      human_owner_id: null,
      whatsapp_owner_id: null,
    };
    return {
      emailStaging: {},
      smsStaging: {},
      filtersDialog: false,
      templateDialog: false,
      botTemplatesDialog: false,
      ivrTemplatesDialog: false,
      testTemplateDialog: false,
      smsConfigDialog: false,
      templateChannel: '',
      templateChannelId: 0,
      emptyForm,
      form: _.cloneDeep(emptyForm),
      filtersListKey: uuidv1(),
      types: [
        {
          id: 1,
          label: 'Regular',
        },
        {
          id: 2,
          label: 'Dual hora fija',
        },
        {
          id: 3,
          label: 'Dual hora IA',
        },
      ],
    };
  },
  computed: {
    canCreate() {
      return this.checkPermissions([
        'create_workflow_notifications',
        'edit_workflow_notifications',
      ]);
    },
    activeFilters() {
      return typeof this.form.filters === 'object';
    },
    activateCheck() {
      return (
        (
          this.templateChannel === 'email'
          || this.templateChannel === 'sms'
        )
        && (this.filter || {}).template_id
        && !!(this.filter || {})[this.templateChannel]
      );
    },
    templateStaging() {
      if (this.templateChannel === 'email') {
        return this.emailStaging && this.emailStaging || {};
      } else {
        return this.smsStaging && this.smsStaging || {};
      }
    },
    maxOrder() {
      let order = (this.stage.filters || []).length;
      if (!Object.keys(this.filter).length) {
        order += 1;
      }
      return order;
    },
    testTemplateId() {
      let id = 0;
      if (this.templateChannelId === 4) {
        id = this.form.bot_template_id;
      } else if (this.templateChannelId === 3) {
        id = this.form.ivr_template_id;
      } else {
        id = this.filter.template_id || 0;
      }
      return id;
    },
    template() {
      return {
        ...this.templateChannel === 'email' && {
          company_email_id: this.form.company_email_id,
          subject: this.form.subject,
        },
        text: this.form[this.templateChannel] || '',
      };
    },
    editMode() {
      return Object.keys(this.filter).length > 0;
    },
    dialogTitle() {
      return `${!Object.keys(this.filter).length ? 'Crear' : 'Editar'} estrategia`;
    },
    filteredChannels() {
      return this.channels.filter(item => ['email', 'sms', 'ivr', 'bot', 'human', 'visit', 'whatsapp'].includes(item.name));
    },
    botTemplate() {
      return {
        bot_template_id: this.form.bot_template_id,
        max_attempts: this.form.bot_max_attempts,
      };
    },
    ivrTemplate() {
      return {
        ivr_template_id: this.form.ivr_template_id,
        max_attempts: this.form.ivr_max_attempts,
      };
    },
  },
  methods: {
    deleteFilter() {
      this.$emit('delete', {filter: this.filter, stage: this.stage});
    },
    setStaging() {
      this.axios.get(`templates/staging/${this.filter.template_id}`)
        .then(response => {
          const { data } = response;
          if (data.length) {
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              if (element.channel_id === 1) {
                this.emailStaging = { ...element, text: element.body };
                delete this.emailStaging.body;
              } else if (element.channel_id === 2) {
                this.smsStaging = { ...element, text: element.body };
                delete this.smsStaging.body;
              }
            }
          } else {
            this.emailStaging = {};
            this.smsStaging = {};
          }
        })
        .catch(() => {
          this.emailStaging = {};
          this.smsStaging = {};
        });
    },
    testTemplate(templateChannel, id) {
      this.templateChannel = templateChannel;
      this.templateChannelId = id;
      this.testTemplateDialog = true;
    },
    openTemplateDialog(templateChannel) {
      this.templateChannel = templateChannel;
      if (templateChannel === 'bot') {
        this.botTemplatesDialog = true;
      } else if (templateChannel === 'ivr') {
        this.ivrTemplatesDialog = true;
      } else {
        this.templateDialog = true;
      }
    },
    saveTemplate(form) {
      if (form.momentToApply === 'now' || !['create', 'update'].includes(form.actionType)) {
        const templateForm = {
          ...this.templateChannel === 'email' && {
            company_email_id: form.company_email_id,
            subject: form.subject,
          },
          [this.templateChannel]: form.text,
        };
        this.form = {
          ...this.form,
          ...templateForm,
        };
        if (this.activateCheck) {
          this.axios.patch(`v2/workflow_filters/${this.filter.id}`, {
            ...templateForm,
          })
            .then((response) => {
              this.$emit('updated', response.data);
            })
            .catch(() => { });
        }
      } else {
        if (form.channel === 'email') {
          this.emailStaging = form;
          form.channel_id = 1;
        } else {
          this.smsStaging = form;
          form.channel_id = 2;
        }

        if (form.actionType === 'create') {
          this.axios.post('templates/staging', {
            ...form,
            company_id: this.$auth.user().company_id,
            template_id: this.filter.template_id,
            type: 'workflow_notification',
          })
            .then(() => EventBus.$emit('modal', 'Guardado exitoso'))
            .catch(() => EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente'));
        } else if (form.actionType === 'update') {
          this.axios.patch(`templates/staging/${this.filter.template_id}`, {
            ...form,
            company_id: this.$auth.user().company_id,
            template_id: this.filter.template_id,
            type: 'workflow_notification',
          })
            .then(() => EventBus.$emit('modal', 'Plantilla actualizada con éxito'))
            .catch(() => EventBus.$emit('modal', 'Error al guardar, por favor intente nuevamente'))
        }
      }
    },
    closeDialog() {
      this.$emit('close');
      setTimeout(() => {
        this.form = {
          ...this.emptyForm,
        };
        this.filters = [];
      }, 200);
    },
    save() {
      const form = {
        ..._.omit(this.form, ['filters', 'no_management']),
      };
      form.filters = this.form.filters;
      form.no_management = this.form.no_management ? 1 : 0;
      form.fixed_hour = this.form.fixed_hour ? moment(this.form.fixed_hour, 'HH:mm').format('HH:mm') : this.form.fixed_hour;
      if (Object.keys(this.filter).length) {
        this.axios.patch(`v2/workflow_filters/${this.filter.id}`, form)
          .then((response) => {
            this.$emit('updated', response.data);
            this.$emit('close');
          })
          .catch((e) => {
            const keys = Object.keys(e.response.data.errors);
            for (let i = 0; i < keys.length; i += 1) {
              this.$validator.errors.add({
                field: keys[i],
                msg: e.response.data.errors[keys[i]][0],
                scope: 'filter'
              });
            }
          });
      } else {
          if(typeof form.filters !== 'string') {
            form.filters = JSON.stringify(form.filters);
          }
        this.axios.post(`stages/${this.stage.id}/filters`, form)
          .then((response) => {
            this.$emit('created', response.data);
            this.$emit('close');
          }).catch((e) => {
            const keys = Object.keys(e.response.data.errors);
            for (let i = 0; i < keys.length; i += 1) {
              this.$validator.errors.add({
                field: keys[i],
                msg: e.response.data.errors[keys[i]][0],
                scope: 'filter',
              });
            }
          });
      }
    },
    saveBotTemplate(form) {
      this.form.bot_template_id = form.bot_template_id;
      this.form.bot_max_attempts = form.max_attempts;
    },
    saveIvrTemplate(form) {
      this.form.ivr_template_id = form.ivr_template_id;
      this.form.ivr_max_attempts = form.max_attempts;
    },
    openSmsConfigDialog() {
      this.smsConfigDialog = true;
    },
  },
  watch: {
    'form.filters'() { // eslint-disable-line
      if(typeof this.form.filters === 'string') {
          this.form.filters = JSON.parse(this.form.filters);
        }
    },
    'form.no_management'() { // eslint-disable-line
      if (this.show && this.form.no_management) {
        this.filteredChannels.forEach((item) => {
          this.form[`send_${item.name}`] = 0;
        });
      }
    },
    show() {
      if (!this.editMode) {
        setTimeout(() => {
          let newOrder;
          if(this.stage.filters) {
            newOrder = this.stage.filters.length + 1
          } else {
            newOrder = 1;
          }
          this.form = {
            ..._.cloneDeep(this.emptyForm),
            order: newOrder,
          };
        }, 200);
      } else {
        this.form = {
          ..._.pick(this.filter, Object.keys(this.emptyForm)),
        };
        if(typeof this.form.filters === 'string') {
          this.form.filters = JSON.parse(this.form.filters);
        }
      }
      if (!this.show) {
        setTimeout(() => {
          this.$validator.errors.clear('filter');
        }, 500);
      }
      this.filtersListKey = uuidv1();
      if (this.activateCheck) {
        this.setStaging();
      }
    },
  },
};
</script>

<style scoped>
.custom-checkbox {
  width: 210px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/WorkflowDetail/editModal.vue